module.exports = __webpack_public_path__ + "static/media/actions-outline.42d0702b.svg";